import React, { useMemo } from "react";
import { FaUserCircle } from "react-icons/fa";

const Profile = ({ onClose, onLogout }) => {
	const user = useMemo(
		() => ({
			nome: sessionStorage.getItem("nome"),
			username: sessionStorage.getItem("username"),
			email: sessionStorage.getItem("email"),
		}),
		[]
	);

	const handleOverlayClick = (e) => {
		if (e.target === e.currentTarget && onClose) onClose();
	};

	const handleLogout = () => {
		if (onLogout) onLogout();
	};

	return (
		<div
			className="fixed inset-0 z-50 flex items-center justify-center p-4"
			style={{ background: "rgba(12, 19, 31, 0.55)", backdropFilter: "blur(8px)" }}
			onClick={handleOverlayClick}
		>
			<div className="w-full max-w-xl rounded-2xl shadow-2xl p-6" style={{ background: "linear-gradient(135deg, rgba(141,196,235,0.9), rgba(35,100,174,0.5))" }}>
				<div className="flex justify-between items-center mb-4 text-white">
					<div className="flex items-center gap-3">
						<FaUserCircle className="text-4xl" />
						<div>
							<p className="text-sm opacity-80">Profilo</p>
							<p className="text-lg font-semibold leading-tight">{user.nome || "Utente"}</p>
						</div>
					</div>
					<button
						type="button"
						onClick={onClose}
						className="text-white/80 hover:text-white text-lg font-semibold"
						aria-label="Chiudi profilo"
					>
						×
					</button>
				</div>

				<div className="space-y-3">
					<div>
						<label className="label-text text-white/80">Nome</label>
						<input type="text" value={user.nome || ""} className="input-text bg-white/80" readOnly />
					</div>
					<div>
						<label className="label-text text-white/80">Username</label>
						<input type="text" value={user.username || ""} className="input-text bg-white/80" readOnly />
					</div>
					<div>
						<label className="label-text text-white/80">Email</label>
						<input type="email" value={user.email || ""} className="input-text bg-white/80" readOnly />
					</div>
				</div>

				<div className="flex justify-end gap-3 mt-6">
					<button
						type="button"
						onClick={handleLogout}
						className="button-prophet px-4 py-2 text-sm"
						style={{ background: "linear-gradient(135deg, rgba(192,57,43,0.85), rgba(192,57,43,0.95))", borderRadius: "12px" }}
					>
						Logoff
					</button>
					<button
						type="button"
						onClick={onClose}
						className="button-prophet px-4 py-2 text-sm"
						style={{ borderRadius: "12px" }}
					>
						Chiudi
					</button>
				</div>
			</div>
		</div>
	);
};

export default Profile;
